module.exports = "./img/9f284ba52ed3f1035c9fbaec0f97c076.png";